import * as classes from "./load-progress.module.scss";

const LoadProgress = ({ progress }: { progress: number }) => {
  return (
    <div className={classes.root}>
      <div
        className={classes.inner}
        style={{ width: progress.toLocaleString("en", { style: "percent" }) }}
      ></div>
    </div>
  );
};

export default LoadProgress;
